import { Link } from "react-router-dom";
import { Sparkles } from "lucide-react";
import { useMe } from "@/context/MeContext";
import { eur } from "@/lib/api";
import { PointsEarn } from "@/components/club/PointsEarn";

export function HouseOffersBox({ offers }) {
  const { me } = useMe();
  if (!offers?.length) return null;
  const status = me?.status || "bronze";
  return (
    <div data-testid="house-offers-box" className="house-blink rounded-2xl border-2 border-amber-400 bg-gradient-to-br from-amber-500/20 via-amber-500/10 to-transparent p-5">
      <p className="flex items-center gap-2 font-display text-lg font-bold text-amber-300">
        <Sparkles className="h-5 w-5" /> Ce l'abbiamo noi! Compralo dal club e prendi il TRIPLO dei punti
      </p>
      <div className="mt-4 space-y-3">
        {offers.map((o) => (
          <Link key={o.id} to={`/marketplace/${o.id}`} data-testid={`house-offer-${o.id}`} className="flex items-center gap-4 rounded-xl bg-[#0B0C10]/70 p-3 transition-colors hover:bg-[#0B0C10]">
            <img src={o.image_url} alt={o.name} loading="lazy" className="h-16 w-16 shrink-0 rounded-lg bg-white object-contain p-1" onError={(e) => (e.currentTarget.style.visibility = "hidden")} />
            <div className="min-w-0 flex-1">
              <p className="line-clamp-2 text-sm font-semibold text-white">{o.name}</p>
              <p className="text-xs text-slate-400">{o.stock > 0 ? `Disponibili: ${o.stock}` : "Esaurito"} · spedizione 9,90 €, gratis sopra 100 €</p>
              <PointsEarn amount={o[`price_${status}`]} multiplier={3} label="Punti x3" testid={`house-offer-points-${o.id}`} />
            </div>
            <div className="text-right">
              <p className="font-display text-xl font-bold text-white">{eur(o[`price_${status}`])}</p>
              <span className="mt-1 inline-block rounded-full bg-amber-500 px-3 py-1 text-xs font-bold text-black">Compra da noi</span>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
